// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import { GeneralTaskConfigDTO, ProcedureReportProps } from '../../../../Types/LogT';
import { WorkflowS } from '../../../../Service/WorkflowS';
import { getReportExecutionState } from './reportExecutionState';

const DeleteTaskReport: FC<ProcedureReportProps> = ({ report, config }) => {
  const { taskReference } = config as GeneralTaskConfigDTO;
  const { label } = taskReference ?? {};
  const executionState = getReportExecutionState(report?.executionStatus);

  return (
    <Text>
      {executionState === 'SKIPPED' ? 'Löschen der Aufgabe' : 'Aufgabe'}{' '}
      <Text span weight="bolder">
        {label}
      </Text>{' '}
      {executionState === 'COMPLETED' && 'wurde gelöscht.'}
      {executionState === 'PLANNED' && 'wird gelöscht.'}
      {executionState === 'SKIPPED' && 'wurde übersprungen.'}
      {executionState === 'NOT_EXECUTED' && 'wurde nicht gelöscht.'}
      {WorkflowS.getWorkflowErrorDescription(report)}
    </Text>
  );
};

export default DeleteTaskReport;
